import type { FunctionComponent } from 'react';

/**
 * ListHeaderText displays header text with the
 * correct font-size and weight.
 */
const ListHeaderText: FunctionComponent = ({ children }) => (
  <span className="fossa-font-size-sm fossa-font-weight-medium">
    {children}
  </span>
);

export default ListHeaderText;
